var _defs, _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserProfileV1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Calque_1",
    "data-name": "Calque 1",
    viewBox: "0 0 486 487.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#81b3e1;}.cls-1{opacity:0.4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "userV1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 243,
    cy: 243,
    r: 243
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M356.09,178.62a91,91,0,1,1-90.95,91,91.06,91.06,0,0,1,90.95-91Z",
    transform: "translate(-113 -87)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M356,574.71A202,202,0,0,1,224.55,526.2,38.78,38.78,0,0,1,211,496.7c0-50.93,41.26-91.7,92.18-91.7H409.09a91.59,91.59,0,0,1,92,91.7,38.76,38.76,0,0,1-13.56,29.5A202.07,202.07,0,0,1,356,574.71Z",
    transform: "translate(-113 -87)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfileV1);
export default __webpack_public_path__ + "static/media/user-profile-v1.647ba021.svg";
export { ForwardRef as ReactComponent };